<footer class="site-footer">
  © Apartments of Houston. All Rights Reserved.
</footer>
